import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, TextButton, Modal, useMediaQuery } from 'bonfire-kindling';

import ModalTitle from '../ModalTitle/ModalTitle';

const OpportunityViewButton = ({
  isBonfireOrganization,
  externalLink,
  openBonfireOpportunity,
  ...props
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobileWidth = useMediaQuery(theme => theme.breakpoints.down('sm'));

  const onClose = () => setIsModalOpen(false);

  if (!isBonfireOrganization && !externalLink) {
    return null;
  }

  return (
    <>
      <TextButton
        onClick={e => {
          if (isBonfireOrganization) {
            openBonfireOpportunity(e);
          } else {
            setIsModalOpen(true);
          }
        }}
        {...props}
      />
      <Modal
        open={isModalOpen}
        onClose={onClose}
        aria-labelledby="leaving-pv-modal-title"
        aria-describedby="leaving-pv-modal-subtitle"
        size={isMobileWidth ? 'tiny' : 'medium'}
      >
        <ModalTitle
          onClose={onClose}
          titleId="leaving-pv-modal-title"
          subtitleId="leaving-pv-modal-subtitle"
          subtitle={t('opportunities.project.leaving_pv_modal_subtitle')}
        >
          {t('opportunities.project.leaving_pv_modal_title')}
        </ModalTitle>
        <Box
          display="flex"
          padding={isMobileWidth ? '1rem 1rem' : '1rem 2rem'}
          justifyContent="end"
        >
          <TextButton
            variant="outlined"
            onClick={onClose}
            label={t('opportunities.project.leaving_pv_modal_cancel')}
            sx={{ marginRight: 3 }}
          />
          <TextButton
            component="a"
            rel="noreferrer noopener"
            target="_blank"
            href={externalLink}
            label={t('opportunities.project.leaving_pv_modal_continue')}
            onClick={onClose}
          />
        </Box>
      </Modal>
    </>
  );
};

export default OpportunityViewButton;
